import {
    UPDATE_PASSWORD_MASTERDATA_USER,
    REMOVE_LISTS,
} from "./actions";

const initialState = {
    loading: false,
    check: true,
    update_status: null,
    error_msg: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case REMOVE_LISTS:
            return initialState;

        case UPDATE_PASSWORD_MASTERDATA_USER.REQUEST:
        return {
            ...state,
            // check: false,
            loading: true,
            error_msg: "",
        };

        case UPDATE_PASSWORD_MASTERDATA_USER.SUCCESS:
            console.log("action.payload : ", action.payload)
            return {
              ...state,
              loading: false,
              update_status: action.payload,
            };

        case UPDATE_PASSWORD_MASTERDATA_USER.FAILURE:
            return {
                ...state,
                loading: false,
                error_msg: action.payload.error,
              };

        default:
            return state;
    }
}